import React, { useEffect } from 'react';
import { useController, useFormContext } from 'react-hook-form';
import FormControl from '@mui/material/FormControl';
import Typography from '@mui/material/Typography';
import PropTypes from 'prop-types';
import FormControlLabel from '@mui/material/FormControlLabel';
import FormHelperText from '@mui/material/FormHelperText';

import { StyledCheckbox } from './styles';

export const VpHookFormCheckbox = ({
  name = '',
  defaultValue = false,
  required = false,
  rules = {},
  disabled = false,
  onChange = null,
  label = '',
  helperText = '',
  disableHelperText = true,
  disablePadding = true,
  ...rest
}) => {
  const id = `vp-hook-checkbox-${name}`;
  const displayInputName = `${name}-display`;

  // prevents issues where defaultValue is null
  const defaultInputValue = defaultValue || false;
  const { setValue, register } = useFormContext();
  const {
    field: { onChange: onControllerChange, onBlur, value, name: inputName, ref },
    fieldState: { error }
  } = useController({
    name: displayInputName,
    rules: { required, ...rules },
    defaultValue: defaultInputValue,
    shouldUnregister: true
  });

  useEffect(() => {
    setValue(name, value);
  }, [value]);

  useEffect(() => {
    setValue(name, defaultInputValue);
    setValue(displayInputName, defaultInputValue);
  }, [defaultInputValue]);

  // helper text spacing will always be there so we don't "push down" elements
  const errorMessage = error?.message;
  const defaultHelperText = disableHelperText ? '' : <span>&nbsp;</span>;
  const helperTextMessage = errorMessage || helperText || defaultHelperText;

  const onSelectChange = (e) => {
    onControllerChange(e);
    onChange && onChange(e);
  };

  return (
    <FormControl fullWidth variant="outlined">
      <FormControlLabel
        control={
          <StyledCheckbox
            inputRef={ref}
            id={id}
            onChange={onSelectChange}
            onBlur={onBlur}
            checked={value}
            name={inputName}
            disabled={disabled}
            disablePadding={disablePadding}
            {...rest}
          />
        }
        label={<Typography variant="checkboxLabel">{label}</Typography>}
      />
      <input
        {...register(name)}
        type="checkbox"
        style={{ display: 'none' }}
        defaultChecked={defaultValue}
      />
      <FormHelperText error={!!error} id={`${id}-helper-text`}>
        {helperTextMessage}
      </FormHelperText>
    </FormControl>
  );
};

VpHookFormCheckbox.propTypes = {
  name: PropTypes.string.isRequired,
  defaultValue: PropTypes.bool,
  required: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  rules: PropTypes.object,
  disabled: PropTypes.bool,
  onChange: PropTypes.func,
  label: PropTypes.string,
  placeholder: PropTypes.string,
  helperText: PropTypes.string,
  disableHelperText: PropTypes.string,
  disablePadding: PropTypes.bool
};

export default VpHookFormCheckbox;



// WEBPACK FOOTER //
// ./src/vp-ui/inputs/VpHookFormCheckbox/VpHookFormCheckbox.jsx